import { render, staticRenderFns } from "./AddReciboSuelto.vue?vue&type=template&id=2b5e35aa"
import script from "./AddReciboSuelto.vue?vue&type=script&lang=js"
export * from "./AddReciboSuelto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports